import { render, staticRenderFns } from "./TaskReports.vue?vue&type=template&id=89d12324&scoped=true"
import script from "./TaskReports.vue?vue&type=script&lang=js"
export * from "./TaskReports.vue?vue&type=script&lang=js"
import style0 from "./TaskReports.vue?vue&type=style&index=0&id=89d12324&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d12324",
  null
  
)

export default component.exports